export default "__VITE_ASSET__15c3bef2__"